import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function Hero() {
  return <section className="relative flex flex-col items-center justify-center overflow-hidden pt-32 pb-10 px-4 sm:px-6 lg:px-8" data-id="element-29">
      {/* Background */}
      <div className="absolute inset-0 z-0 bg-gradient-to-br from-[#050505] via-[#0a0a0a] to-[#001a22] opacity-80" data-id="element-30">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(0,229,255,0.1)_0%,transparent_50%)]" data-id="element-31" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto text-center" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-33">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 mb-8" data-id="element-34">
            <span className="w-2 h-2 rounded-full bg-[#00E5FF] animate-pulse" data-id="element-35" />
            <span className="text-sm font-medium text-gray-300 tracking-wide uppercase" data-id="element-36">
              Estudio Creativo con IA
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold tracking-tight mb-6 leading-[1.1] md:leading-[1.2]" data-id="element-37">
            <span className="text-white" data-id="element-38">Deja de quemar presupuesto</span>{' '}
            <br className="hidden sm:block" data-id="element-39" />
            <span className="text-gradient-blue text-4xl sm:text-6xl md:text-8xl font-black block mt-2 sm:mt-0" data-id="element-40">
              con creativos que no segmentan.
            </span>
          </h1>

          <p className="mt-6 sm:mt-8 text-lg sm:text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto font-medium leading-relaxed mb-4 px-2" data-id="element-41">
            Activa tu fábrica de Ads con IA hoy mismo. Producción masiva de
            activos validados por algoritmos.
          </p>
        </motion.div>
      </div>

      {/* Separator Line */}
      <div className="absolute bottom-0 left-0 right-0 w-full flex justify-center" data-id="element-42">
        <div className="w-full max-w-5xl h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" data-id="element-43" />
      </div>

      {/* Decorative bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#050505] to-transparent z-10 pointer-events-none" data-id="element-44" />
    </section>;
}